<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.product") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <base-button size="md" type="neutral" @click="handleCreate()">{{
            $t("new")
          }}</base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
             <div class="row">
 <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>

                <div class="col-md-1">
                 <base-button
                  size="md"
                  type="neutral"
                  @click="ProductExport()"
                >
                  Export
                </base-button>
              </div>
             </div>
          </template>
          <div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
            >
				<el-table-column >
					<div slot-scope="{  row }" class="d-flex">
						<img :src="GetProductUrl(row.Image)" height="100px" v-if="row.Image.includes('.png') || row.Image.includes('.jpg') || row.Image.includes('jpeg')"/>
					</div>
			</el-table-column>

              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <el-table-column
                min-width="200px"
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
				<base-button
                    @click.native="handleBarcode($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-barcode"></i>
                  </base-button>

                  <base-button
                    @click.native="handleEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-edit"></i>
                  </base-button>
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-trash text-white"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('wms.product_name')"
          v-model="md.name"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          :label="$t('wms.product_pn')"
          v-model="md.part_number"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          :label="$t('wms.barcode')"
          v-model="md.barcode"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

		<div class="row">
			<div class="col-md-3">
				<base-input :label="$t('wms.width')" v-model="md.width"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.height')" v-model="md.height"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.depth')" v-model="md.depth"/>
			</div>
			<div class="col-md-3">
				<base-input :label="$t('wms.weight')" v-model="md.weight"/>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<base-input :label="$t('wms.threshold')" v-model="md.threshold"/>
			</div>

		</div>

		<div class="row">
			<div class="col-md-6">
				<base-input :label="$t('wms.cost')" v-model="md.cost"/>
			</div>
			<div class="col-md-6">
				<base-input
				:label="$t('wms.partner')"
				input-classes="form-control-alternative new-event--title"
				>
				<el-select v-model="md.partner_id" :placeholder="$t('wms.partner')">
					<el-option
					v-for="option in tablePartner"
					:key="option.ID"
					:label="option.CompanyName"
					:value="option.ID"
					>
					</el-option>
				</el-select>
				</base-input>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<base-input :label="$t('image')" :name="$t('image')" >
					<file-input rules="required" @change="filesChange" ref="fileImage"></file-input>
				</base-input>
			</div>
			<div class="col-md-6">
				<img :src="GetProductUrl(md.image)" height="200px" v-if="md.image.includes('.png') || md.image.includes('.jpg') || md.image.includes('jpeg')"/>
				<img v-if="!md.image.includes('.png') && !md.image.includes('.jpg') && !md.image.includes('jpeg')  && md.image != '' && md.image != null && md.image!= undefined " :src="md.image" height="200px" />
			</div>
		</div>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import FileInput from "@/components/Inputs/FileInput";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
	FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableData: "WmsProduct/getData",
      tablePartner: "WmsPartner/getData",
    }),
    // tableData: function () {
    //   if (this.SearchKeyword != "") {
    //     return this.tableDataOrg.filter((d) => {
    //       return d.Name.indexOf(this.SearchKeyword) != -1 || d.BarCode.indexOf(this.SearchKeyword) != -1
    //     });
    //   } 

    //   return this.tableDataOrg;
    // },
    tableColumns: function () {
      return [
        {
          prop: "Name",
          label: this.$t("wms.product_name"),
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "CompanyName",
          label: this.$t("wms.partner"),
          minWidth: 100,
          sortable: true,
        },
        // {
        //   prop: "Amount",
        //   label: this.$t("wms.balance"),
        //   minWidth: 90,
        // },
        {
          prop: "ManPN",
          label: this.$t("wms.product_pn"),
          minWidth: 90,
        },
        {
          prop: "BarCode",
          label: this.$t("wms.barcode"),
          minWidth: 90,
        },
        {
          prop: "Cost",
          label: this.$t("wms.cost"),
          minWidth: 90,
        },
		{
          prop: "Threshold",
          label: this.$t("wms.threshold"),
          minWidth: 90,
        },
      ];
    },
  },
  data() {
    return {
      propsToSearch: ["Name", "BarCode"],
      selectedRows: [],
      showAddModal: false,
      SearchKeyword: "",
      md: {
        id: 0,
        name: "",
        partner_id: "",
        part_number: "",
        barcode: "",
        width: 0,
        height: 0,
        depth: 0,
        weight: 0,
        cost: 0,
		image:"",
		threshold:0,
      },
      partner: [{ label: "MadameFin", value: 1 }],
    };
  },
  mounted() {
    this.listData();
	this.listPartner();
  },
  methods: {
    ...mapActions({
      createData: "WmsProduct/createData",
      updateData: "WmsProduct/updateData",
      deleteData: "WmsProduct/deleteData",
      listData: "WmsProduct/listData",
      listPartner: "WmsPartner/listData",
      getBarcode: "WmsProduct/getBarcode",
	  
    }),

    ProductExport() {
      const csvString = [
        ["สินค้า",  "คงเหลือ", "Barcode"],
        ...this.tableDataOrg.map((item) => [
          item.Name,
          item.Amount,
          item.BarCode,
        ]),
      ]
        .map((e) => e.join(","))
        .join("\n");

      let csvContent = "data:text/csv;charset=utf-8,\ufeff" + csvString;
      // var universalBOM = "\uFEFF";
      // var encodedUri = encodeURIComponent(universalBOM+csv);
      // window.open(encodedUri);

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "product.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    handleCreate() {
      this.showAddModal = true;
      this.md.id = 0;
      this.md.partner_id = this.tablePartner.length > 0 ? this.tablePartner[0].ID : 0;
      this.md.part_number = "";
      this.md.name = "";
      this.md.barcode = "";
      this.md.width = 0;
      this.md.height = 0;
      this.md.depth = 0;
      this.md.weight = 0;
	  this.md.image = "";
	  this.md.threshold = 0;
    },
	handleBarcode(index,row){
		console.log(row)
		this.getBarcode({
          barcode: row.BarCode,
          type: "base64",
        })
          .then((resp) => {
            console.log(resp.data)
			swal.fire({
  title: row.Name,
  html: '<img src="'+resp.data+'">' + row.BarCode,
  showCloseButton: false,
  showCancelButton: false,
  focusConfirm: false,
  confirmButtonText:
    'Close',
  confirmButtonAriaLabel: 'Thumbs up, great!',

})
          })
          .catch((err) => {
            swal.fire({
              title: "สร้าง Barcode ผิดพลาด",
              text: "Barcode : " + row.BarCode,
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });

	},
    handleEdit(index, row) {
      this.showAddModal = true;
      this.md.id = row.ID;
      this.md.partner_id = row.PartnerID;
      this.md.part_number = row.ManPN;
      this.md.name = row.Name;
      this.md.barcode = row.BarCode;
      this.md.width = row.SizeWidth;
      this.md.height = row.SizeHeight;
      this.md.depth = row.SizeDepth;
      this.md.weight = row.Weight;
      this.md.cost = row.Cost;
	  this.md.image = row.Image == null ? "": row.Image;
	  this.md.threshold = row.Threshold
	  this.$refs.fileImage.clearFile()
	},
    handleUpdate() {
      this.showAddModal = false;

      if (this.md.id == 0) {
        // create
        this.createData({
          Name: this.md.name,
          ManPN: this.md.part_number,
          PartnerID: this.md.partner_id,
          SizeHeight: parseInt(this.md.height),
          SizeDepth: parseInt(this.md.depth),
          SizeWidth: parseInt(this.md.width),
          Weight: parseInt(this.md.weight),
          BarCode: this.md.barcode,
          Cost: parseFloat(this.md.cost),
		  Image : this.md.image,
		  Threshold: parseInt(this.md.threshold)
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      } else {
        // update

        this.updateData( {
          id: this.md.id,
		  payload : {
          Name: this.md.name,
          ManPN: this.md.part_number,
          PartnerID: this.md.partner_id,
          SizeHeight: parseInt(this.md.height),
          SizeDepth: parseInt(this.md.depth),
          SizeWidth: parseInt(this.md.width),
          Weight: parseInt(this.md.weight),
          BarCode: this.md.barcode,
          Cost: parseFloat(this.md.cost),
		  Image : this.fileNameIsImage(this.md.image) ? "": this.md.image ,
		  Threshold: parseInt(this.md.threshold)
		  }
        })
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteData(row.ID)
              .then((resp) => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              })
              .catch((err) => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false,
                });
              });
          }
        });
    },
	filesChange(files) {
		if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
			swal.fire({
				title: "Error",
				text: "กรุณาเลือกไฟล์รูปภาพ",
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false
			});

			this.$refs.fileImage.clearFile();
			return;
		}


		if (files[0].size > 1024 * 1024 *2) {
			swal.fire({
				title: "Error",
				text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
				icon: "error",
				confirmButtonClass: "btn btn-danger btn-fill",
				buttonsStyling: false
			});
			this.$refs.fileImage.clearFile();
			return;
		}

		const reader = new FileReader();
		reader.readAsDataURL(files[0]);
		reader.onload = () => {
			this.md.image = reader.result;
		};
	},

	GetProductUrl(filename){
		console.log("FileName " + filename)
		return process.env.VUE_APP_API_BASE_URL + "/files/wms/" + filename
	},
	fileNameIsImage(filename) {
		return filename.includes(".png") || filename.includes(".jpg") || filename.includes(".jpeg")
	}
},
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
